import React, { useContext } from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import './spinner.css';

import commonTranslations from '../languages/common.json';
import { LanguageContext } from '../context/LanguageContext';

const Spinner = () => {
  const { lang } = useContext(LanguageContext);
  const t = commonTranslations[lang].common.Spinner;
  return (
    <div className='spinner-container'>
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" >
        {t.connecting}
      </Typography>
    </div>
  );
};

export default Spinner;